<template>
  <div v-if="getSeries().length > 0" style="min-height: 24rem">
    <e-chart :option="chartOption" style="width: 100%; height: 400px" />
  </div>
  <div v-else class="no-data">
    {{ $t('containers.noValues') }}
  </div>
</template>

<script>
import { graphic } from 'echarts'
import moment from 'moment'

const chartSeriesDefaults = {
  type: 'line',
  symbol: 'none',
  smooth: true,
  sampling: 'average',
  areaStyle: {
    normal: {
      color: new graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: 'rgb(136, 214, 77)',
        },
        {
          offset: 1,
          color: 'rgb(81, 195, 126)',
        },
      ]),
    },
  },
}

export default {
  props: {
    chartValues: { type: Array },
    chartManualValues: { type: Array },
    emptyingDates: { type: Array },
  },
  computed: {
    chartOption() {
      return {
        tooltip: {
          trigger: 'axis',
          position: pt => [pt[0], '10%'],
        },
        legend: {
          textStyle: { lineHeight: 16 },
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#838f98',
            },
          },
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLabel: {
            color: '#69727a',
          },
          axisLine: {
            lineStyle: {
              color: '#838f98',
            },
          },
        },
        dataZoom: [
          {
            end: 100,
            filterMode: 'none',
            startValue: moment().subtract(1, 'month').format(),
            type: 'inside', // can zoom around with mouse in the chart
          },
          {
            type: 'slider', // component under chart to view and adjust zoom
            filterMode: 'none',
            show: true,
            realtime: true,
            startValue: moment().subtract(1, 'month').format(),
            end: 100,
            xAxisIndex: [0, 1],
          },
        ],
        series: this.getSeries(),
      }
    },
  },
  methods: {
    getSeries() {
      let series = [
        {
          ...chartSeriesDefaults,
          name: this.$t('containerValuesChart.values'),
          data: this.chartValues,
          itemStyle: {
            normal: { color: '#1abc9c' },
          },
        },
        {
          ...chartSeriesDefaults,
          name: this.$t('containerValuesChart.manualValues'),
          data: this.chartManualValues?.map(x => [x[0], x[1] > 100 ? 100 : x[1]]),
          itemStyle: {
            normal: { color: '#1a1cac' },
          },
          areaStyle: null,
          step: 'start',
        },
        {
          ...chartSeriesDefaults,
          name: this.$t('containerValuesChart.emptyingDates'),
          data: this.emptyingDates,
          itemStyle: {
            normal: { color: '#1a53ff' },
          },
          lineStyle: {
            width: 0,
          },
          symbol: 'pin',
          symbolSize: 20,
          areaStyle: null,
        },
        {
          type: 'scatter',
          name: this.$t('containerValuesChart.highValues'),
          data: this.chartManualValues?.filter(x => x[1] > 100)?.map(x => [x[0], 100]),
          tooltip: {
            show: false,
          },
          symbolOffset: [0, -20],
          color: 'red',
          symbolSize: 18,
          symbol:
            'path://M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 192a58.432 58.432 0 0 0-58.24 63.744l23.36 256.384a35.072 35.072 0 0 0 69.76 0l23.296-256.384A58.432 58.432 0 0 0 512 256zm0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4z',
        },
      ]
      return series.filter(x => x.data?.length > 0)
    },
  },
}
</script>
